import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from 'views/Main'
Vue.use(VueRouter)

// 解决重复点击跳转报错
// const originalPush = VueRouter.prototype.originalPush
// VueRouter.prototype.push = function push(location){
//   return originalPush.call(this,location).catch( err => err)
// }

const routes = [
  {
    path: '',
    redirect: 'main'
  },
  {
    path: '/main',
    component:Main,
    children: [
      {
        path: '',
        redirect: 'index',
        meta:{
          title:' Home'
        }
      },
      {
        path: 'index',
        name:'index',
        component: () => import('views/computer/index/Index'),
        meta:{
          title:' Home'
        }
      },
      {
        path: 'news',
        name:'news',
        component: () => import('views/computer/news/Index'),
        meta:{
          title:'News'
        }
      },
      {
        path: 'ndetail',
        name:'ndetail',
        component: () => import('views/computer/news/Detail'),
        meta:{
          title:'News Details'
        }
      },
      {
        path: 'qkan',
        name:'qkan',
        component: () => import('views/computer/qkan/Index'),
        meta:{
          title:'Academic Journals'
        }
      },
      {
        path: 'qdetail',
        name:'qdetail',
        component: () => import('views/computer/qkan/Detail'),
        meta:{
          title:'Journal Details'
        }
      },
      {
        path: 'lyan',
        name:'lyan',
        component: () => import('views/computer/lyan/Index'),
        meta:{
          title:'Message Board'
        }
      },
      {
        path: 'add',
        name:'add',
        component: () => import('views/computer/lyan/Add'),
        meta:{
          title:'Initiate a Message'
        }
      },
      {
        path: 'comment',
        name:'comment',
        component: () => import('views/computer/comment/Index'),
        meta:{
          title:'Evaluation Center'
        }
      },
      {
        path: 'contact',
        name:'contact',
        component: () => import('views/computer/contact/Index'),
        meta:{
          title:'Contact Us'
        }
      },
      {
        path: 'login',
        name:'login',
        component: () => import('views/computer/login/Index'),
        meta:{
          title:'login'
        }
      },
      {
        path: 'checkny',
        name:'checkny',
        component: () => import('views/computer/checkny/Index'),
        meta:{
          title:'Journal Verification'
        }
      },
      {
        path: 'cdetail',
        name:'cdetail',
        component: () => import('views/computer/checkny/Detail'),
        meta:{
          title:'Journal Verification'
        }
      }
    ]
  },
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
